// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"ZK-z","sponsoredTooltipWrapper":"_K-z","sponsoredTooltip":"aL-z","newCard":"bL-z"};